var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isArray(_vm.listAffiliate))?_c('div',{staticClass:"sampleAffPage"},_vm._l((_vm.listAffiliate),function(item,index){return _c('AffiliateAdvisorPreviewItem',{key:index,attrs:{"dataListAff":item.form,"uploadedImage":item?.uploadedImage[0]}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }